import React, { useMemo } from 'react'

import { PlusOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { useOperatorData } from '@contexts/operator/OperatorDataContext'
import { useIsStandard } from '@contexts/operator/PlanContext'
import { useOperatorOrderTemplateService } from '@hooks/operator/order_templates/useOperatorOrderTemplateService'
import OrderTemplatesList from '@shared/order_templates/OrderTemplatesList'
import ListPageHeader from '@shared/ListPageHeader'

export default function OperatorOrderTemplatesList() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { merchants, salesChannels, merchantId } = useOperatorData()
  const isStandard = useIsStandard()

  const orderTemplateService = useOperatorOrderTemplateService({ merchantId })

  const merchantOptions = useMemo(() => {
    return merchants.map(merchant => ({
      label: merchant.name,
      value: merchant.id
    }))
  }, [merchants])

  const salesChannelOptions = useMemo(() => {
    return salesChannels.map(channel => ({
      label: channel.name,
      value: channel.id
    }))
  }, [salesChannels])

  return (
    <div>
      <ListPageHeader
        items={['orders', 'orders.templates']}
        actions={
          <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate('/order_templates/new')}>
            {t('common.button.new')}
          </Button>
        }
      />
      <OrderTemplatesList
        service={orderTemplateService}
        role="operator"
        merchantOptions={merchantOptions}
        salesChannelOptions={salesChannelOptions}
        hideMerchantUI={isStandard}
      />
    </div>
  )
}
